import { axiosHelper } from 'Services/AxiosHelper';
import { CustomerCardApplicationListModel } from 'Models';
import { onCustomerApplicationListBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnCustomerApplicationList';

const onCustomerApplicationList = async (
  params: onCustomerApplicationListBodyData
): Promise<CustomerCardApplicationListModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onCustomerApplicationList;
